// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var Relude_IO = require("relude/src/Relude_IO.bs.js");
var BrowserStyle = require("../../../../shared-browser/src/BrowserStyle.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var Relude_Result = require("relude/src/Relude_Result.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");
var BrowserComponents_Button = require("../../../../shared-browser/src/components/BrowserComponents_Button.bs.js");
var BrowserComponents_Spacer = require("../../../../shared-browser/src/components/BrowserComponents_Spacer.bs.js");
var BrowserComponents_FlexRow = require("../../../../shared-browser/src/components/BrowserComponents_FlexRow.bs.js");
var BrowserComponents_ValidationError = require("../../../../shared-browser/src/components/BrowserComponents_ValidationError.bs.js");

var button = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.mobileMedia({
            hd: BrowserStyle.flex({
                  NAME: "num",
                  VAL: 1.0
                }),
            tl: {
              hd: BrowserStyle.flexBasis(BrowserStyle.zero),
              tl: /* [] */0
            }
          }),
      tl: /* [] */0
    });

var buttonsContainer = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.alignSelf(BrowserStyle.center),
      tl: {
        hd: BrowserStyle.mobileMedia({
              hd: BrowserStyle.alignSelf(BrowserStyle.stretch),
              tl: /* [] */0
            }),
        tl: /* [] */0
      }
    });

var Styles = {
  button: button,
  buttonsContainer: buttonsContainer
};

function WebComponents_SettingsFormActionButtons(Props) {
  var cancelButtonTitleOpt = Props.cancelButtonTitle;
  var isSubmitting = Props.isSubmitting;
  var onCancel = Props.onCancel;
  var showError = Props.showError;
  var submitButtonTitle = Props.submitButtonTitle;
  var submitButtonBusyTitle = Props.submitButtonBusyTitle;
  var cancelButtonTitle = cancelButtonTitleOpt !== undefined ? cancelButtonTitleOpt : "Cancel";
  var partial_arg = Relude_IO.pure(undefined);
  return React.createElement(BrowserComponents_FlexRow.make, {
              className: buttonsContainer,
              children: null
            }, React.createElement(BrowserComponents_Button.make, {
                  actionPriority: /* LegacySecondary */2,
                  className: button,
                  disabled: isSubmitting,
                  onClick: (function (param) {
                      return onCancel;
                    }),
                  testId: "cancelButton",
                  title: cancelButtonTitle
                }), React.createElement(BrowserComponents_Spacer.make, {
                  size: /* Medium */4
                }), React.createElement(BrowserComponents_Button.make, {
                  actionPriority: /* Primary */0,
                  className: button,
                  disabled: isSubmitting,
                  onClick: (function (param) {
                      return Relude_Globals.$$const(partial_arg, param);
                    }),
                  testId: "submitButton",
                  title: isSubmitting ? submitButtonBusyTitle : submitButtonTitle,
                  type_: "submit"
                }), showError ? React.createElement(BrowserComponents_ValidationError.make, {
                    validationResult: Relude_Option.pure(Relude_Result.error("There was an error. Please try again or contact support."))
                  }) : null);
}

var make = WebComponents_SettingsFormActionButtons;

exports.Styles = Styles;
exports.make = make;
/* button Not a pure module */
